import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModuleState {
  selectedModule: string | null;
  isVideoMinimize: boolean;
  isCallJoined: boolean;
}

const initialState: ModuleState = {
  selectedModule: null,
  isVideoMinimize: false,
  isCallJoined: false,
};

const moduleSlice = createSlice({
  name: "module",
  initialState,
  reducers: {
    selectModule: (state, action: PayloadAction<string | null>) => {
      state.selectedModule = action.payload;
    },
    setIsVideoMinimize: (state, action: PayloadAction<boolean>) => {
      state.isVideoMinimize = action.payload;
    },
    setIsCallJoined: (state, action: PayloadAction<boolean>) => {
      state.isCallJoined = action.payload;
    },
  },
});

export const { selectModule, setIsVideoMinimize, setIsCallJoined } =
  moduleSlice.actions;

export default moduleSlice.reducer;
